import { render, staticRenderFns } from "./Binding.vue?vue&type=template&id=648fec91&scoped=true&"
import script from "./Binding.vue?vue&type=script&lang=js&"
export * from "./Binding.vue?vue&type=script&lang=js&"
import style0 from "./Binding.vue?vue&type=style&index=0&id=648fec91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648fec91",
  null
  
)

export default component.exports